import React from 'react'
import ItemTemplate from './ItemTemplate'
import { getText } from '../../lib/text.js'

/**
 *
 */

const Block = props => {
  const item = props.item
  return (
    <ItemTemplate
      {...props}
      title={<span>{getText("Plantilla: "+item.name)}</span>}
      description={""}
      subtitle={""}
      icon="list"
      modal={<span />}
    />
  )
}

export default Block
